"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const string_utils_1 = require("@/common/string_utils");
function default_1({ expand }) {
    var _a;
    let cartTotal = 0;
    const cart = (0, react_redux_1.useSelector)((state) => state.cart);
    cart.forEach(item => (cartTotal += item.amount * item.price));
    const isEmptyCart = !Boolean(cart === null || cart === void 0 ? void 0 : cart.length);
    let customDeliveryPrice = 0;
    const customDeliveryId = (0, react_redux_1.useSelector)((state) => state.customDeliveryId);
    const deliveries = (0, react_redux_1.useSelector)((state) => state.roomData.deliveries);
    if (customDeliveryId) {
        customDeliveryPrice =
            ((_a = deliveries.find(delivery => delivery.id === customDeliveryId)) === null || _a === void 0 ? void 0 : _a.delivery_price) || 0;
        cartTotal += customDeliveryPrice;
    }
    const orderTotalCss = expand
        ? {
            display: 'flex',
            justifyContent: 'center',
            padding: '8px 0 14px',
            fontSize: '16px',
            color: 'rgba(0, 0, 0, 0.8)',
        }
        : {
            fontFamily: 'inherit',
        };
    const { t } = (0, react_i18next_1.useTranslation)();
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const salesClosed = (0, react_redux_1.useSelector)((state) => state.roomData.salesClosed);
    if (expand) {
        if (isDemandSurvey && salesClosed) {
            return (0, jsx_runtime_1.jsx)("div", Object.assign({ css: orderTotalCss }, { children: `🧡 ${t('곧 판매로 만나요!')} 🧡` }));
        }
        if (isEmptyCart && !salesClosed) {
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: orderTotalCss }, { children: [isDemandSurvey ? ((0, jsx_runtime_1.jsx)("span", Object.assign({ css: { fontWeight: 'bold' } }, { children: t('정보 작성은 다음 화면') }))) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ css: { fontWeight: 'bold' } }, { children: t('작성/결제는 다음 화면') }))), (0, jsx_runtime_1.jsx)("span", { children: t('에서') })] })));
        }
    }
    if (!cartTotal || salesClosed)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: orderTotalCss }, { children: [expand && (0, jsx_runtime_1.jsxs)("span", { children: [t('총 구매금액'), "\u00A0"] }), (0, jsx_runtime_1.jsxs)("span", Object.assign({ translate: "no", id: "order_total", css: { fontWeight: 'bold', fontFamily: 'inherit' } }, { children: [(0, string_utils_1.money)(cartTotal), t('원')] })), !expand && (0, jsx_runtime_1.jsx)("span", { children: "\u00A0" })] })));
}
exports.default = default_1;
